//
// PluggableQuery.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../QueryBase";

var PluggableQuery = createModule("BIRD::PluggableQuery", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::QueryBase"], EventDispatcher, [
    ,
    {
        resource: 7,
        reportPart: 7,
        directive: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default PluggableQuery;
